<template>
  <div class="quick_container">
    <div class="quick_header">
      <div class="quick_div" @click="clickQuick" v-if="selectQuick === true">
        <div class="quick_btn">
          <img
            src="../../../static/talks/t_quicked.png"
            style="width: 16px; height: 14px"
          />
          <label class="quick_title_selected">快捷回复</label>
        </div>
        <div class="blue_line"></div>
      </div>
      <div class="quick_div" @click="clickQuick" v-else>
        <div class="quick_btn">
          <img
            src="../../../static/talks/t_quick.png"
            style="width: 16px; height: 14px"
          />
          <label class="quick_title">快捷回复</label>
        </div>
        <div></div>
      </div>
      <div class="quick_div" @click="clickVisit" v-if="selectVisit === true">
        <div class="quick_btn">
          <img
            src="../../../static/talks/t_visitored.png"
            style="width: 16px; height: 14px"
          />
          <label class="quick_title_selected">访客信息</label>
        </div>
        <div class="blue_line"></div>
      </div>
      <div class="quick_div" @click="clickVisit" v-else>
        <div class="quick_btn">
          <img
            src="../../../static/talks/t_visitor.png"
            style="width: 16px; height: 14px"
          />
          <label class="quick_title">访客信息</label>
        </div>
        <div></div>
      </div>
    </div>
    <div class="gray_line"></div>
    <div class="search_div" v-if="selectQuick == true">
      <el-input
        class="search_input"
        placeholder="请输入内容"
        suffix-icon="el-icon-search"
        clearable
        @input="highLightText"
        v-model="filterText"
      >
      </el-input>
      
      <el-select
        style="margin-right: 0.1875rem"
        class="search_inputxx"
        v-if="$store.state.authority.isQuickShow"
        v-model="selectCollege"
        placeholder="请选择同事"
        @change="collegeChange"
        clearable
        @clear="selectCollege = ''"
      >
        <el-option
          v-for="item in collegeOptions"
          :key="item.id"
          :label="item.realName"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <br />
    </div>

    <!-- 快捷回复  -->
    <div
      style="width: 100%; padding: 0 3px; box-sizing: border-box"
      v-show="selectQuick === true && filterText === ''"
      v-loading="loading"
      class="aside_div"
      ref="aside_divRef"
    >
      <el-collapse v-model="quicklyActiveName" accordion>
        <!-- 个人快捷回复  -->
        <div style="position: relative">
          <el-collapse-item name="1">
            <template slot="title">
              <div
                class="custom_title"
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  width: 100%;
                  max-width: 100%;
                "
              >
                <div class="title_left">
                  <img
                    v-show="quicklyActiveName === '1'"
                    class="aside_div_icon"
                    src="../../../static/talks/icon_fullscreen4.png"
                    alt="加载失败"
                  />
                  <img
                    v-show="quicklyActiveName !== '1'"
                    class="aside_div_icon"
                    src="../../../static/talks/icon_fullscreen2.png"
                    alt="加载失败"
                  />
                  个人快捷回复
                </div>
                <div class="buttons">
                  <div
                    class="aside_div_edit"
                    v-show="selectCollege === null"
                    @click.stop="showButtons = showButtons ? false : true"
                  >
                    {{ !showButtons ? "编辑" : "取消编辑" }}
                  </div>
                  <div
                    class="aside_div_add"
                    @click.stop="dialogQuicklyVisible = true"
                    v-show="selectCollege === null"
                  >
                    添加
                  </div>
                </div>
              </div>
            </template>
            <div class="aside_div" v-show="filterText === ''">
              <el-tree
                v-if="treePersonData.length > 0"
                :accordion="true"
                :draggable="true"
                :allow-drop="allowDrop"
                @node-drop="handleDrop"
                class="tree_box"
                ref="treeNode"
                :data="treePersonData"
                :props="defaultProps"
                @node-click="handleNodeClick"
                :filter-node-method="filterNode"
                :highlight-current="true"
                :default-expand-all="isExpandAll"
                :default-expanded-keys="defaultExpandKeys"
                @node-expand="handleNodeExpand"
                @node-collapse="handleNodeCollapse"
                style="width: 100%"
                node-key="id"
                empty-text="暂无数据"
              >
                <span
                  class="custom-tree-node"
                  style="position: relative"
                  @mouseenter="handleShowIcon(node, data)"
                  slot-scope="{ node, data }"
                >
                  <span
                    style="
                      display: flex;
                      width: 100%;
                      justify-content: space-between;
                      align-items: center;
                      justify-items: start;
                    "
                    v-if="data.dataType == 0"
                  >
                    <span>{{ node.label }}</span>
                    <span
                      class="custom-tree-icon"
                      v-show="
                        iconIsShow === data.id &&
                        selectCollege === null &&
                        showButtons
                      "
                      style="padding: 0 6px 0 0"
                      @click.stop=""
                    >
                      <img
                        src="../../../static/quick/add.png"
                        @click="add(data)"
                        alt=""
                      />
                      <img
                        src="../../../static/quick/revise.png"
                        @click="handleEdit(currentIndex - 1, data)"
                        alt=""
                      />
                      <img
                        @click="upAndDown(data, 1)"
                        v-show="currentIndex !== 1"
                        src="../../../static/quick/up_arrow.png"
                        alt=""
                      />
                      <img
                        @click="upAndDown(data, 2)"
                        v-show="currentIndex !== treeNodeLength"
                        src="../../../static/quick/down_arrow.png"
                        alt=""
                      />
                      <img
                        @click="deleteRow(data)"
                        src="../../../static/quick/delete.png"
                        alt=""
                      />
                    </span>
                  </span>
                  <div v-if="data.dataType == 1" class="tree-node2">
                    <el-popover
                      placement="left-start"
                      width="200"
                      trigger="hover"
                      v-if="showQuickPreview === true"
                      v-model="data.useFlag"
                      :disabled="data.content.length === 0"
                      :key="data.id"
                    >
                      <slot>
                        <el-button
                          type="primary"
                          size="mini"
                          v-clipboard:copy="data.content"
                          v-clipboard:success="copyText"
                          v-clipboard:error="onError"
                          @click="data.useFlag = !data.useFlag"
                          >复制文字</el-button
                        ><br />
                        <div
                          v-html="renderHtml1(data.content, filterText)"
                        ></div>
                      </slot>

                      <div
                        class="pop_span"
                        slot="reference"
                        v-html="renderHtml2(node.data, filterText)"
                        @mouseenter="handleShowIcon(node, data)"
                      ></div>
                    </el-popover>

                    <div
                      class="pop_span"
                      v-if="showQuickPreview === false"
                      slot="reference"
                      v-html="renderHtml2(node.data, filterText)"
                      @mouseenter="handleShowIcon(node, data)"
                    ></div>
                    <div
                      v-show="
                        iconIsShow === data.id &&
                        selectCollege === null &&
                        showButtons
                      "
                      class="custom-tree-iconBox"
                    >
                      <span
                        class="custom-tree-icon"
                        v-show="iconIsShow === data.id"
                        style="padding: 0 6px 0 0"
                        @click.stop=""
                      >
                        <img
                          @click="add(data)"
                          v-show="data.content.length === 0"
                          src="../../../static/quick/add.png"
                          alt=""
                        />
                        <img
                          src="../../../static/quick/revise.png"
                          @click="handleEdit(currentIndex - 1, data)"
                          alt=""
                        />
                        <img
                          @click="upAndDown(data, 1)"
                          v-show="currentIndex !== 1"
                          src="../../../static/quick/up_arrow.png"
                          alt=""
                        />
                        <img
                          @click="upAndDown(data, 2)"
                          v-show="currentIndex !== treeNodeLength"
                          src="../../../static/quick/down_arrow.png"
                          alt=""
                        />
                        <img
                          @click="deleteRow(data)"
                          src="../../../static/quick/delete.png"
                          alt=""
                        />
                      </span>
                    </div>
                  </div>
                  <hr class="tree-divider" />
                </span>

              </el-tree>

              <div
                class="el-tree__empty-block"
                v-show="treePersonData.length === 0"
              >
                <span class="el-tree__empty-text">暂无数据</span>
              </div>
            </div>
          </el-collapse-item>
        </div>
        <!-- 公共快捷回复 -->
        <div style="position: relative" v-show="selectCollege === null && $store.state.authority.isPublicQuickShow">
          <el-collapse-item name="2">
            <template slot="title">
              <img
                v-show="quicklyActiveName === '2'"
                class="aside_div_icon"
                src="../../../static/talks/icon_fullscreen4.png"
                alt="加载失败"
              />
              <img
                v-show="quicklyActiveName !== '2'"
                class="aside_div_icon"
                src="../../../static/talks/icon_fullscreen2.png"
                alt="加载失败"
              />公共快捷回复
            </template>
            <div class="aside_div">
              <el-tree
                v-if="treeCommonData.length > 0"
                :accordion="true"
                class="tree_box"
                ref="treeComDataRef"
                :data="treeCommonData"
                :props="defaultProps"
                @node-click="handleNodeClick"
                :highlight-current="true"
                :default-expand-all="isExpandAll"
                style="width: 100%"
                node-key="id"
                empty-text="暂无数据"
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span v-if="data.dataType == 0">{{ node.label }}</span>
                  <el-popover
                    placement="left-start"
                    width="200"
                    trigger="hover"
                    v-model="data.useFlag"
                    v-if="showQuickPreview === true"
                  >
                    <slot>
                      <el-button
                        type="primary"
                        size="mini"
                        v-clipboard:copy="data.content"
                        v-clipboard:success="copyText"
                        v-clipboard:error="onError"
                        @click="data.useFlag = !data.useFlag"
                        >复制文字</el-button
                      ><br />
                      <div v-html="renderHtml1(data.content, filterText)"></div>
                    </slot>

                    <div
                      v-if="data.dataType == 1 && data.content.length > 0"
                      v-html="renderHtml2(node.data, filterText)"
                      class="pop_span"
                      slot="reference"
                    ></div>
                  </el-popover>
                  <div
                    v-if="
                      data.dataType == 1 &&
                      data.content.length > 0 &&
                      showQuickPreview === false
                    "
                    v-html="renderHtml2(node.data, filterText)"
                    class="pop_span"
                    slot="reference"
                  ></div>
                  <div
                    class="pop_span1"
                    v-if="
                      data.dataType == 1 &&
                      data.content.length == 0 &&
                      showQuickPreview === true
                    "
                    v-html="renderHtml1(node.label, filterText)"
                  ></div>

                  <div
                    class="pop_span1"
                    v-if="
                      data.dataType == 1 &&
                      data.content.length == 0 &&
                      showQuickPreview === false
                    "
                    v-html="renderHtml1(node.label, filterText)"
                  ></div>
                  <hr class="tree-divider" />
                </span>
              </el-tree>
            </div>
          </el-collapse-item>
        </div>
        <!-- 智能助手话术 -->
        <div style="position: relative" v-show="selectCollege === null">
          <el-collapse-item name="3">
            <template slot="title">
              <img
                v-show="quicklyActiveName === '3'"
                class="aside_div_icon"
                src="../../../static/talks/icon_fullscreen4.png"
                alt="加载失败"
              />
              <img
                v-show="quicklyActiveName !== '3'"
                class="aside_div_icon"
                src="../../../static/talks/icon_fullscreen2.png"
                alt="加载失败"
              />智能助手话术
            </template>
            <div class="aside_div">
              <el-tree
                v-if="treeAIData.length > 0"
                :accordion="true"
                class="tree_box"
                ref="treeAIDataRef"
                :data="treeAIData"
                :props="defaultProps"
                @node-click="handleNodeClick"
                :highlight-current="true"
                :default-expand-all="isExpandAll"
                style="width: 100%"
                node-key="id"
                empty-text="暂无数据"
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span v-if="data.dataType == 0">{{ node.label }}</span>
                  <el-popover
                    placement="left-start"
                    width="200"
                    trigger="hover"
                    v-model="data.useFlag"
                    v-if="showQuickPreview === true"
                  >
                    <slot>
                      <el-button
                        type="primary"
                        size="mini"
                        v-clipboard:copy="data.content"
                        v-clipboard:success="copyText"
                        v-clipboard:error="onError"
                        @click="data.useFlag = !data.useFlag"
                        >复制文字</el-button
                      ><br />
                      <div v-html="renderHtml1(data.content, filterText)"></div>
                    </slot>

                    <div
                      v-if="data.dataType == 1 && data.content.length > 0"
                      v-html="renderHtml2(node.data, filterText)"
                      class="pop_span"
                      slot="reference"
                    ></div>
                  </el-popover>
                  <div
                    v-if="
                      data.dataType == 1 &&
                      data.content.length > 0 &&
                      showQuickPreview === false
                    "
                    v-html="renderHtml2(node.data, filterText)"
                    class="pop_span"
                    slot="reference"
                  ></div>
                  <div
                    class="pop_span1"
                    v-if="
                      data.dataType == 1 &&
                      data.content.length == 0 &&
                      showQuickPreview === true
                    "
                    v-html="renderHtml1(node.label, filterText)"
                  ></div>

                  <div
                    class="pop_span1"
                    v-if="
                      data.dataType == 1 &&
                      data.content.length == 0 &&
                      showQuickPreview === false
                    "
                    v-html="renderHtml1(node.label, filterText)"
                  ></div>
                  <hr class="tree-divider" />
                </span>
              </el-tree>
              <div
                class="el-tree__empty-block"
                v-show="treeAIData.length === 0"
              >
                <span class="el-tree__empty-text">暂无数据</span>
              </div>
            </div>
          </el-collapse-item>
        </div>
      </el-collapse>
    </div>
    <!-- 新建目录  start-->
    <el-dialog
      title="新建目录"
      :visible.sync="dialogQuicklyVisible"
      :close-on-click-modal="false"
      lock-scroll
      center
      top="20vh"
      width="30%"
      class="el-dailog"
    >
      <template slot="title">
        <span class="el-dialog__title">新建目录</span>
      </template>
      <div>
        <el-form @submit.native.prevent label-width="auto">
          <el-form-item label="目录名称：" size="small">
            <el-input v-model="fileData.title"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogQuicklyVisible = false" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="handleTrueAdd" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 新建目录  start-->

    <!-- 编辑快捷回复目录  start-->
    <div class="item_font" v-show="addReply">
      <el-dialog
        :title="act"
        :visible.sync="addReply"
        width="60%"
        center
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
        "
      >
        <el-form
          :model="replyData"
          label-position="left"
          style="display: flex; flex-direction: column; justify-content: center"
        >
          <el-form-item
            :label="[act === '编辑快捷回复目录' ? '回复目录:' : '回复标题:']"
          >
            <el-input v-model="replyData.title"></el-input>
          </el-form-item>
          <el-form-item label="回复内容:" v-show="dataType == 0 ? false : true">
            <el-input
              v-model="replyData.content"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 10}"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addReply = false" class="item_font"
            >取 消</el-button
          >
          <el-button
            type="primary"
            :disabled="
              replyData.title === oldReplyData.title &&
              replyData.content === oldReplyData.content
            "
            @click="condirmAddReply"
            class="item_font"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 编辑快捷回复目录  end-->

    <!-- 添加快捷回复目录 start-->
    <div class="item_font" v-show="addFolders">
      <el-dialog
        :title="act"
        :visible.sync="addFolders"
        width="60%"
        center
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="fileData"
          label-position="left"
          style="display: flex; flex-direction: column; justify-content: center"
        >
          <el-form-item label="目录标题:">
            <el-input v-model="fileData.title"></el-input>
          </el-form-item>
          <!-- <el-form-item label="排列序号:" >
							<el-input v-model="fileData.sortNum"  style="width: 70%;" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入数字0~9999"></el-input>
						</el-form-item> -->
          <el-form-item label="回复内容:" v-show="fileData.dataType === 1">
            <el-input v-model="fileData.content" type="textarea" :autosize="{ minRows: 5, maxRows: 10}"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            @click="
              addFolders = false;
              resetForm();
            "
            class="item_font"
            >取 消</el-button
          >
          <el-button type="primary" @click="handleTrueAdd" class="item_font"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 添加快捷回复目录  end-->

    <!-- 当前为快捷回复一栏，且有搜索内容 -->
    <div
      class="aside_div searchAside_div"
      v-show="selectQuick === true && filterText !== ''"
      ref="searchAside_divRef"
    >
      <div
        class="aside_content"
        v-for="(item, index) in searchedData"
        :key="index"
      >
        <div class="aside_div_lists" @click="handleNodeClick(item)">
          <span>{{ item.title }}</span>
          <el-popover
            placement="left-start"
            width="160"
            trigger="hover"
            v-model="item.useFlag"
            v-if="showQuickPreview === true"
          >
            <slot>
              <el-button
                type="primary"
                size="mini"
                v-clipboard:copy="item.content"
                v-clipboard:success="copyText"
                v-clipboard:error="onError"
                @click="item.useFlag = !item.useFlag"
                >复制文字</el-button
              ><br />
              <div
                class="aside_div_lists-popover"
                v-html="changeKeywords(item.content, filterText)"
              ></div>
            </slot>
            <span
              class="aside_div_lists-content"
              v-html="changeKeywords(item.content, filterText)"
              slot="reference"
            />
          </el-popover>
          <div
            class="aside_div_lists-popover"
            v-if="showQuickPreview === false"
            v-html="changeKeywords(item.content, filterText)"
          ></div>
        </div>
      </div>
    </div>
    <template v-if="selectVisit == true">
      <div
        id="echartsDiv"
        :style="{ width: '100%', height: '500px', marginTop: '20px' }"
      ></div>
    </template>
    <div class="visite_outdiv" v-if="selectVisit == true">
      <div v-if="showVisitInfo == true">
        <div v-for="(item, index) in visitMsgList" :key="index">
          <div class="visite_box" v-if="item.type == 1">
            <label class="title_lb">访客信息</label>
            <div class="content_div" v-if="item.name.length > 0">
              访客名称：{{ item.name }}
            </div>
            <div class="content_div" v-if="item.cid.length > 0">
              访客ID：{{ item.cid }}
            </div>
            <div class="content_div" v-if="item.sid.length > 0">
              会话ID：{{ item.sid }}
            </div>
            <div class="content_div" v-if="item.first.length > 0">
              首次访问：{{ item.first }}
            </div>
            <div class="content_div" v-if="item.first.length > 0">
              本次访问：{{ item.now }}
            </div>
            <div class="content_div" v-if="item.staytime.length > 0">
              本次停留：{{ item.staytime }}
            </div>
            <div class="content_div" v-if="item.total > 0">
              累计来访：{{ item.total }}次
            </div>
          </div>
          <div class="visite_box" v-if="item.type == 2">
            <label class="title_lb">来源信息</label>
            <div class="content_div" v-if="item.brower.length > 0">
              当前浏览：{{ item.brower }}
            </div>
            <div class="content_div" v-if="item.site.length > 0">
              所属站点：{{ item.site }}
            </div>
          </div>
          <div class="visite_box" v-if="item.type == 3">
            <label class="title_lb">系统信息</label>
            <div class="content_div" v-if="item.px.length > 0">
              分辨率：{{ item.px }}
            </div>
            <div class="content_div" v-if="item.color.length > 0">
              颜色深度：{{ item.color }}
            </div>
            <div class="content_div" v-if="item.osystem.length > 0">
              操作系统：{{ item.osystem }}
            </div>
            <div class="content_div" v-if="item.brower.length > 0">
              浏览器：{{ item.brower }}
            </div>
            <div class="content_div" v-if="item.language.length > 0">
              语言：{{ item.language }}
            </div>
            <div class="content_div" v-if="item.browerTip.length > 0">
              浏览器标头：{{ item.browerTip }}
            </div>
          </div>
          <div class="visite_box" v-if="item.type == 4">
            <label class="title_lb">访客轨迹</label>
            <div class="content_div">关键词：{{ item.key }}</div>
            <div v-for="(data, idx) in item.dataList" :key="idx">
              <div class="content_div1" v-if="data.account.length == 0">
                {{ data.time }}[{{ data.action }}]-{{ data.desc }}
              </div>
              <div class="content_div1" v-else>
                {{ data.time }}[{{ data.action }}]-{{ data.desc }}推广账户{{
                  data.account
                }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="visite_box"
          v-if="(trailList != null) & (trailList.length > 0)"
        >
          <label class="title_lb">访客轨迹</label>
          <div v-for="(data, idx) in trailList" style="width: 100%" :key="idx">
            <div class="content_div1">
              {{ data.time }}[{{ data.source }}]-{{ data.desc }}
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <img class="noData_img" src="../../../static/talks/t_novisitor.png" />
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import "echarts-wordcloud/dist/echarts-wordcloud";
import "echarts-wordcloud/dist/echarts-wordcloud.min";
import { MessageBox } from "element-ui";

export default {
  name: "JwChat-talk",
  data() {
    return {
      fileData: {
        id: "",
        pId: "0",
        title: "",
        content: "",
        attributionType: 1,
        dataType: 0,
        // sortNum:"",
      },
      // 当前新增目录类型
      currentType: "",
      activeIndex: "1",
      visible: false,
      itemQuick: "",
      input2: "",
      selectQuick: true,
      selectVisit: false,
      trailList: [],
      showVisitInfo: false,
      visitMsgList: [
        {
          type: 1, //访客信息
          name: "",
          cid: "",
          sid: "",
          first: "",
          now: "",
          staytime: "",
          total: "",
        },
        {
          type: 2, //来源信息
          brower: " ",
          site: "",
        },
        {
          type: 3, //系统信息
          px: "",
          color: "",
          osystem: "",
          brower: "",
          language: "",
          staytime: "",
          browerTip: "",
        },
      ],
      collegeOptions: [],
      selectCollege: null,
      treeData: [],
      treePersonData: [],
      treeCommonData: [],
      // 智能助手话术数据
      treeAIData: [],
      // 搜索后的数据
      searchedData: [],
      defaultProps: {
        children: "quickReplyVoList",
        // label: 'title',
        label: "title",
        // function(data) {
        // 	if (data.dataType === 0) {
        // 		return data.title
        // 	} else if (data.dataType === 1) {
        // 		return data.title
        // 	}
        // },
        popshow: "content",
      },
      filterText: "",
      isExpandAll: false,
      loading: true,
      worddata: [],
      chart: "",
      charttime: "",
      image: "",
      quicklyActiveName: "1",
      // 添加快捷回复弹窗
      dialogQuicklyVisible: false,
      // icon 是否显示
      iconIsShow: "",
      // 查询相关
      selData: {
        page: 1,
        id: null,
        attributionType: 1,
        userId: this.util.getLocalAccount().id,
      },
      currentIndex: null,
      treeNodeLength: null,
      // 回复数据
      replyData: {
        id: "",
        pId: 0,
        title: "",
        content: "",
        attributionType: 1,
        dataType: 1,
        // sortNum:200,
      },
      // 旧回复数据内容
      oldReplyData: {
        title: "",
        content: "",
      },
      rowId: "",
      // 添加回复弹窗
      addReply: false,
      act: "",
      // 节点类型
      dataType: 0,
      // 记录当时节点
      defaultExpandKeys: [],
      // 添加目录弹窗
      addFolders: false,
      currentPersonData: "",
      showButtons: false,
      windowHeight: window.innerHeight,
      searchAside_divRef: null,

      // 展示快捷预览
      showQuickPreview: false,
    };
  },

  computed: {
    visitor() {
      console.log("quickTalk computed visitor");
      console.log(" $store.state.authority.isPublicQuickShow =" +  this.$store.state.authority.isPublicQuickShow);
      console.log(
        "quickTalk computed visitor ikey = ",
        this.$store.state.selectedKey
      );

      if (this.$store.state.colleageAngle) {
        return this.$store.state.college.nowSelectClient;
      } else {
        return this.$store.state.selectedClient;
      }
    },
  },
  // components: {
  //   VueEasyTree
  // },
  watch: {
    filterText(val) {
      console.log("filterText:", this.filterText);
      if (val === "") {
        console.log("搜索词为空val：", val);
        return;
      } else {
        // this.searchedData.splice(0, this.searchedData.length, "");
        this.searchedData = [];
        console.log("watch filterTExt treeData:", this.treeData);
        // 排除没有目录的
        var newTreeData = this.treeData.filter((item) => {
          if (item.quickReplyVoList || item.content) {
            return item;
          }
        });
        console.log("watch filterTExt treePersonData:", this.treePersonData);
        var tempSearchedData = [];
        // 双重遍历后，判断内容中是否含有搜索词
        newTreeData.forEach((item) => {
          this.getSearchDate(item, val, tempSearchedData);
        });
        this.searchedData = tempSearchedData;
        if (this.searchAside_divRef !== null) {
          this.$nextTick(() => {
            this.searchAside_divRef = this.$refs.searchAside_divRef;
            this.searchAside_divRef.style.maxHeight =
              this.windowHeight - this.searchAside_divRef.offsetTop + "px";
            console.log(
              "searchAside_divRef:",
              this.windowHeight - this.searchAside_divRef.offsetTop
            );
          });
        }

        console.log("搜索词不为空：", val, this.searchedData);
      }
      // if (val == "") {
      //   this.quickRequest();
      // }
      // else {
      //   this.$refs.tree.filter(val);
      // }
    },

    visitor(newVal, oldVal) {
      console.log("quickTalk watch visitor newVal = ", newVal);
      console.log("quickTalk watch visitor oldVal = ", oldVal);
      console.log("this.selectVisit: ", this.selectVisit);
      if (this.selectVisit) {
        this.visitRequest();
      }
    },
  },

  created() {
    console.log("quickTalk created");
    this.getCollegesRequest();
    this.quickRequest();
    this.getAllConfRequest();
  },

  mounted() {
    console.log("useid", this.util.getLocalAccount().id);
    this.getQuickReplyMaxHeight();

    window.addEventListener("storage", (e) => {
      console.log("成功进入");
      console.log(e.key);
      if (e.key === "quickylySwitch") {
        var el_tree = this.$refs.treeNode.store.root;
        var el_tree2 = this.$refs.treeComDataRef.store.root;
        var el_tree3 = this.$refs.treeAIDataRef ? this.$refs.treeAIDataRef.store.root : null;
        if (e.newValue === "true") {
          this.isExpandAll = true;
          for (let i = 0; i < el_tree.childNodes.length; i++) {
            el_tree.childNodes[i].expanded = true;
          }
          for (let i = 0; i < el_tree2.childNodes.length; i++) {
            el_tree2.childNodes[i].expanded = true;
          }
          if (el_tree3) {
            for (let i = 0; i < el_tree3.childNodes.length; i++) {
              el_tree3.childNodes[i].expanded = true;
            }
          }
        } else {
          this.isExpandAll = false;
          for (let i = 0; i < el_tree.childNodes.length; i++) {
            el_tree.childNodes[i].expanded = false;
          }
          for (let i = 0; i < el_tree2.childNodes.length; i++) {
            el_tree2.childNodes[i].expanded = false;
          }
          if (el_tree3) {
            for (let i = 0; i < el_tree3.childNodes.length; i++) {
              el_tree3.childNodes[i].expanded = false;
            }
          }
        }
      } else if (e.key === "quickReplyISchange") {
        console.log("快捷回复数据改变--个人");
        this.quickRequest();
      } else if (e.key === "quickCommonReplyISchange") {
        console.log("快捷回复数据改变--公共");
        this.quickCommonRequest();
      } else if (e.key === "quickPreviewSwitch") {
        localStorage.setItem("quickPreviewSwitch", e.newValue);
        if (e.newValue === "false") {
          this.showQuickPreview = false;
        } else {
          this.showQuickPreview = true;
        }

        // const el_tree = this.$refs.treeNode.root.store;
        // const el_tree2 = this.$refs.treeComDataRef.root.store;
        // for (let i = 0; i < el_tree.childNodes.length; i++) {
        //   el_tree.childNodes[i] =JSON.parse(JSON.String(el_tree.childNodes[i]))

        // }
        // for (let i = 0; i < el_tree2.childNodes.length; i++) {
        //   el_tree2.childNodes[i] =JSON.parse(JSON.String(el_tree2.childNodes[i]))
        // }

        console.log("quickTalk mounted quickPreviewSwitch", e.newValue);
      }
    });

    // 监听智能助手话术数据
    window.addEventListener("aiAssistantData", this.handleAIAssistantEvent);
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener("aiAssistantData", this.handleAIAssistantEvent);
  },
  methods: {
    // 处理智能助手话术事件
    handleAIAssistantEvent(e) {
      console.log("接收到智能助手话术数据:", e.detail);
      this.handleAIDataUpdate(e.detail);
    },
    async getAllConfRequest() {
      var api = "/manager/settingConfig/selectConfigList";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      console.log("index.vue getAllConfRequest response = ", response);
      if (response.resultCode === "10000") {
        const paraList = response.data;
        for (var i = 0; i < paraList.length; i++) {
          const parameter = paraList[i];
          if (parameter.id === "16") {
            const item = parameter.jsonParamList[0];
            localStorage.setItem("quickPreviewSwitch", item.isSelect);
            this.showQuickPreview = item.isSelect;
          }
        }
      } else {
        this.$message.error(response.desc);
      }
    },

    allowDrop(draggingNode,dropNode,type) {
      if (draggingNode.level === dropNode.level) {
        return type === "prev" || type === "next";
      }else {
        return false;
      }
    },

    async handleDrop(draggingNode,dropNode,dropType,ev) {
      console.log("draggingNode="+ draggingNode + "dropType=" + dropType + "ev="+ev );
      var list = [];
      var index = 100;
      for (let item of dropNode.parent.childNodes) {
        console.log("item ===", item);
        list.push({
          createId:item.data.createId,
          id:item.data.id,
          pId:item.data.pId,
          sort:item.data.sort == null? 0:item.data.sort,
          sortNum:index
        });
        index ++;
      }

      var api = "/manager/quickReply/quickReplyMove";
      var response = {};
      response = await this.util.postRequest({
          url: api,
          method: "POST",
          data: list,
      });
      console.log("response====" + response);

    },

    // 复制文字
    copyText(e) {
      console.log("quilcTalk.vue copyText 复制", e.text);
      this.$message.success("复制文字成功");
      this.$store.state.copyText = e.text;
    },
    onError(e) {
      console.log("quilcTalk.vue onError 报错", e);
    },
    // 计算快捷回复maxHeight
    getQuickReplyMaxHeight() {
      var aside_divRef = this.$refs.aside_divRef;
      var commonEl = document.querySelectorAll(".aside_div .el-collapse-item");
      var elLength = aside_divRef.offsetTop;
      // console.log("this:", this);
      // console.log("this.$refs:", this.$refs);
      // console.log("this.$refs.aside_divRef", this.$refs.aside_divRef);
      // console.log("aside_divRef", aside_divRef);
      // console.log("aside_divRef.offsetParent", aside_divRef.offsetParent);
      // console.log("elLength:", elLength);
      for (let i = 0; i < commonEl.length; i++) {
        const element = commonEl[i];
        elLength += element.children[0].offsetHeight + 1;
        console.log("element：", element);
        console.log(
          "commonListRef---xx--------",
          element.children[0].offsetHeight
        );
      }
      console.log("this.windowHeight:", this.windowHeight);
      console.log("elLength:", elLength);
      console.log("maxHeight:", this.windowHeight - elLength);
      var commonEl_children = document.querySelectorAll(
        ".aside_div .el-collapse-item__content"
      );
      for (let i = 0; i < commonEl_children.length; i++) {
        const element = commonEl_children[i];
        element.style.maxHeight = this.windowHeight - elLength + "px";
        console.log("element:", element);
      }
    },
    // 添加回复
    async add(row) {
      this.fileData.dataType = 1;
      this.fileData.pId = row.id;
      this.fileData.title = "";
      this.fileData.content = "";
      this.act = "新增快捷回复标题";
      this.addFolders = true;
    },
    // // 添加二级目录和内容
    // async condirmAddFolder() {
    //   console.log("condirmAddFolder", this.fileData);
    //   // console.log(this.isRoot)
    //   if (this.fileData.pId != "") {
    //     if (this.fileData.title != "") {
    //       var api = "/manager/quickReply/add";
    //       this.fileData.sortNum = Number(this.fileData.sortNum);
    //       const response = await this.util.postRequest({
    //         url: api,
    //         method: "POST",
    //         data: this.fileData,
    //       });

    //       if (response.resultCode === "10000") {
    //         if (this.fileData.dataType == 1) {
    //           this.$message.success("新增回复成功");
    //         } else {
    //           this.$message.success("创建目录成功");
    //         }
    //         this.addFolders = false;
    //         this.fileData = {
    //           pId: "0",
    //           title: "",
    //           content: "",
    //           attributionType: 1,
    //           dataType: 0,
    //           sortNum: "",
    //         };
    //         this.quickReplySel();
    //       } else {
    //         this.$message.error(response.desc);
    //       }
    //     } else {
    //       const tipMsg = "目录标题不能为空";
    //       MessageBox.alert(tipMsg, "提示", {
    //         confirmButtonText: "确定",
    //         cancelButtonText: null,
    //         type: "warning",
    //         showCancelButton: false,
    //       });
    //     }
    //   }
    // },
    resetForm() {
      this.fileData = {
        id: "",
        pId: "0",
        title: "",
        content: "",
        attributionType: 1,
        dataType: 0,
        // sortNum:"",
      };
    },
    // 编辑回复
    handleEdit(index, row) {
      console.log(index, row);
      this.addReply = true;
      this.replyData = {
        id: row.id,
        title: row.title,
        content: row.content,
      };
      this.oldReplyData = {
        title: row.title,
        content: row.content,
      };
      this.dataType = row.dataType;
      if (row.pId === "0") {
        this.act = "编辑快捷回复目录";
      } else {
        this.act = "编辑快捷回复内容";
      }
    },
    // 提交编辑、添加回复的内容
    async condirmAddReply() {
      if (this.replyData.title != "") {
        var api = "";
        var response = {};
        if (this.act == "编辑快捷回复标题" || this.act == "编辑快捷回复内容") {
          api = "/manager/quickReply/edit";
          response = await this.util.postRequest({
            url: api,
            method: "POST",
            data: this.replyData,
          });
        } else if(this.act ==  "编辑快捷回复目录") {
          api = "/manager/quickReply/edit";
          response = await this.util.postRequest({
            url: api,
            method: "POST",
            data: this.replyData,
          });
        } else {
          api = "/manager/quickReply/add";
          response = await this.util.postRequest({
            url: api,
            method: "POST",
            data: this.replyData,
          });
        }
        if (response.resultCode === "10000") {
          this.replyData = {
            id: "",
            pId: 0,
            title: "",
            content: "",
            attributionType: 1,
            dataType: 1,
          };
          this.oldReplyData = {
            title: "",
            content: "",
          };
          this.addReply = false;
          this.act = "";
          this.quickReplySel();
          this.$message.success("保存成功");
        } else {
          this.$message.error(response.desc);
        }
      } else {
        const tipMsg = "标题不能为空";
        MessageBox.alert(tipMsg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: null,
          type: "warning",
          showCancelButton: false,
        });
      }
    },
    // 上移下移回复
    async upAndDown(row, source) {
      this.replyData = {
        id: row.id,
        // pId: row.pId,
        title: row.title,
        content: row.content,
      };
      this.oldReplyData = {
        title: row.title,
        content: row.content,
      };
      if (source === 1) {
        // 上移
        this.replyData.sortNum = this.currentIndex - 1;
      } else {
        // 下移
        this.replyData.sortNum = this.currentIndex + 1;
      }
      var api = "/manager/quickReply/upAndDown";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: this.replyData,
      });
      if (response.resultCode === "10000") {
        this.$message.success("移动成功");
        this.quickReplySel();
      } else {
        this.$message.error(response.desc);
      }
    },
    // 删除回复
    deleteRow(row) {
      const tipMsg = "是否确认删除";
      MessageBox.alert(tipMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showCancelButton: true,
      })
        .then(() => {
          this.deleteReply(row.id, row);
          if (!row.children || row.pId !== "0") {
            this.rowId = "";
          } else {
            this.rowId = row.pId;
          }
        })
        .catch(() => {
          this.$message.info("取消删除");
        });
    },
    async deleteReply(id, row) {
      var api = "/manager/quickReply/del";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          id: id,
        },
      });
      console.log(response);
      if (response.resultCode === "10000") {
        const tipMsg = "删除快捷回复成功!";
        this.$message.success(tipMsg);
      } else {
        this.$message.error(response.desc);
      }
      this.quickReplySel("删除", row);
    },
    //确定添加一级目录
    async handleTrueAdd() {
      console.log("condirmAddFolder", this.fileData.pId);
      // console.log(this.isRoot)
      if (this.fileData.pId != "") {
        if (this.fileData.title != "") {
          var isSameTitle = null;
          if (this.currentPersonData.quickReplyVoList) {
            isSameTitle = this.currentPersonData.quickReplyVoList.some(
              (item) => {
                console.log(item.title);
                console.log(this.fileData.title);
                return item.title === this.fileData.title;
              }
            );
          }
          if (!this.currentPersonData.quickReplyVoList || !isSameTitle) {
            var api = "/manager/quickReply/add";
            this.fileData.sortNum = Number(this.fileData.sortNum);
            const response = await this.util.postRequest({
              url: api,
              method: "POST",
              data: this.fileData,
            });
            if (response.resultCode === "10000") {
              if (this.fileData.dataType == 1) {
                this.$message.success("新增回复成功");
              } else {
                this.$message.success("创建目录成功");
              }
              this.dialogQuicklyVisible = false;
              this.addFolders = false;
              this.fileData = {
                pId: "0",
                title: "",
                content: "",
                attributionType: 1,
                dataType: 0,
                sortNum: "",
              };
              this.quickReplySel();
            } else {
              this.$message.error(response.desc);
            }
          } else {
            this.$message.error("目录已存在");
          }
        } else {
          const tipMsg = "目录标题不能为空";
          MessageBox.alert(tipMsg, "提示", {
            confirmButtonText: "m确定",
            cancelButtonText: null,
            type: "warning",
            showCancelButton: false,
          });
        }
      } else {
        const tipMsg = "请选择正确的目录位置";
        MessageBox.alert(tipMsg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: null,
          type: "warning",
          showCancelButton: false,
        });
      }
    },
    // 获取快捷回复内容
    async quickReplySel() {
      console.log("Quick Reply Select userId", this.selData.userId);
      var api = "/manager/quickReply/select";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: this.selData,
      });
      for (var i = 0; i < response.data.length; i++) {
        this.getTree(i, response.data[i]);
      }
      // var result=this.getQuee(response.data)
      this.treePersonData = response.data;
      // this.total = this.tableData.length;
      // this.showData = this.tableData.slice(
      //   (this.page - 1) * 10,
      //   this.page * 10
      // );
      this.loading = false;
      console.log("个人快捷回复数据", response.data);
      this.quickRequest();
    },
    getTree(index, data) {
      data.children = data.quickReplyVoList;
      data.label = data.title;
      data.number = index + 1;
      if (data.children != null) {
        data.index = String(index + 1);
        for (var i = 0; i < data.children.length; i++) {
          this.getTree(i, data.children[i]);
        }
      } else {
        data.index = "\xa0\xa0\xa0\xa0\xa0\xa0" + String(index + 1);
      }
    },

    handleShowIcon(node, data) {
      this.iconIsShow = data.id;
      // 0 --- 1级标题    1---2级标题
      this.currentType = data.dataType;
      // 获取当前节点下标
      let index = null;
      let parentList = node.parent.childNodes;
      parentList.forEach((item, indexs) => {
        if (item.key == data.id) {
          index = indexs;
        }
      });
      this.currentIndex = index + 1; //下标
      this.treeNodeLength = parentList.length;
      // console.log("当前节点node，data", node, data);
      // console.log(
      //   "当前node长度，节点下标",
      //   this.treeNodeLength,
      //   this.currentIndex
      // );
    },
    handleNotShowIcon() {
      this.iconIsShow = "";
    },
    filterNode(value, data) {
      if (data.dataType === 1) {
        // // 得到搜索后的内容
        // this.searchedData.splice(0, this.searchedData.length, null);
        // if (data.content.indexOf(value) !== -1) {
        //   this.searchedData.push({ title: data.title, content: data.content });
        // }
        console.log(value, data);
        return (
          data.title.indexOf(value) !== -1 || data.content.indexOf(value) !== -1
        );
      }
    },

    append(data) {
      console.log("quickTalk append data = ", data);
      // const newChild = { id: id++, label: 'testtest', children: [] };
      // if (!data.children) {
      // 	this.$set(data, 'children', []);
      // }
      // data.children.push(newChild);
    },

    async getCollegesRequest() {
      console.log("quickTalk getCollegesRequest");
      var api = "/manager/user/getCurrentDepartUsers";
      // const account = this.util.getLocalAccount()
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      console.log("quickTalk getCollegesRequest response = ", response);
      if (response.resultCode === "10000") {
        this.collegeOptions = response.data;
      } else {
        this.$message.error(response.desc);
      }
    },

    async collegeChange(itemId) {
      console.log("quickTalk collegeChange item = ", itemId);
      if (itemId.length === 0) {
        this.quickRequest();
      } else {
        this.selectCollege = itemId;
        this.getCollegeQuickRequest(itemId);
      }
    },

    async getCollegeQuickRequest(itemid) {
      console.log("quickTalk getCollegeQuickRequest itemid = ", itemid);
      this.loading = true;
      var api = "/manager/quickReply/selectByUser/" + itemid;
      const response = await this.util.postRequest({
        url: api,
        method: "GET",
      });

      console.log("quickTalk getCollegeQuickRequest response = ", response);
      if (response.resultCode === "10000") {
        console.log("==========", response.data);
        console.log("quickTalk getCollegeQuickRequest data = ", response.data);
        var tempData = response.data;
        this.treeData.splice(0, this.treeData.length);
        tempData.forEach((item) => {
          if (item.attributionType === 1) {
            this.treeData.push(item);
          }
        });
        this.treePersonData = this.treeData;
        this.loading = false;
      } else {
        this.$message.error(response.desc);
      }
    },

    remove(node, data) {
      console.log("quickTalk append node = ", node);
      console.log("quickTalk append data = ", data);
      // const parent = node.parent;
      // const children = parent.data.children || parent.data;
      // const index = children.findIndex(d => d.id === data.id);
      // children.splice(index, 1);
    },

    async quickRequest() {
      console.log("quickTalk quickRequest");
      var api = "/manager/QuickReplyQuery/select";
      const account = this.util.getLocalAccount();
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          id: "",
          attributionType: 3,
          userId: account.id,
        },
      });
      this.selectCollege = null;
      console.log(
        "index quickRequest response = ",
        response.data.map.quickReplyVoList
      );
      console.log("index quickRequest response ====== ", response.data);

      this.isExpandAll = response.data.map.unfold_state;
      // this.isExpandAll = true;
      console.log("  this.isExpandAl： ", this.isExpandAll);
      console.log("  this.selectCollege ", this.selectCollege);
      this.treeData = response.data.map.quickReplyVoList;
      // this.treeData = Object.freeze(response.data.map.quickReplyVoList);
      this.treePersonData.splice(0, this.treePersonData.length);
      this.treeCommonData.splice(0, this.treeCommonData.length);
      this.treeData.forEach((item) => {
        if (item.attributionType === 1) {
          this.treePersonData.push(item);
        } else {
          this.treeCommonData.push(item);
        }
      });
      this.loading = false;
      console.log("  this.selectCollege ", this.selectCollege);
    },
    async quickCommonRequest() {
      var api = "/manager/QuickReplyQuery/select";
      const account = this.util.getLocalAccount();
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          id: "",
          attributionType: 0,
          userId: account.id,
        },
      });
      this.selectCollege = null;
      console.log(
        "index quickRequest response = ",
        response.data.map.quickReplyVoList
      );
      console.log("index quickCommonRequest response ====== ", response.data);
      this.treeCommonData = response.data.map.quickReplyVoList;
    },

    async visitRequest() {
      // const selectClient = this.$store.state.selectedClient
      // console.log('quickTalk visitRequest selected = ', selectClient)
      console.log(
        "0000000000000quickTalk visitRequest visitor = ",
        this.visitor
      );
      // const account = this.util.getLocalAccount()

      if (this.visitor === null) {
        this.showVisitInfo = false;
        return;
      }

      // var csid = account.id
      // if (this.$store.state.keyName === '我的同事') {
      // 	csid = this.$store.state.parentNode.data.data.csid
      // }

      this.showVisitInfo = true;
      var api = "/manager/chat/customer/detail/info";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          cid: this.visitor.cid,
          csid: this.visitor.csid,
          sid: this.visitor.sid,
          page: 1,
          size: 99,
        },
      });
      console.log("index visitRequest response = ", response);
      console.log("index visitRequest cid = ", response.data.cid);
      if (response.data !== null) {
        this.showVisitInfo = true;
        this.getCustBasicInfoAndDisease();
        // let selectClient = this.$store.state.selectedClient
        var type1Obj = this.visitMsgList[0];
        // console.log('nickname = ', selectClient.nickname)
        type1Obj.name = this.visitor.nickname;
        type1Obj.cid = response.data.cid;
        type1Obj.sid = response.data.sid;
        if (response.data.firstVisitTime !== null) {
          type1Obj.first = this.util.timeStampToDate(
            response.data.firstVisitTime,
            1
          );
        }

        if (response.data.thisVisitTime !== null) {
          type1Obj.now = this.util.timeStampToDate(
            response.data.thisVisitTime,
            1
          );
        }

        type1Obj.staytime = this.util.nullToString(response.data.keepTime);
        type1Obj.total = response.data.numberVisitsCount;

        var type2Obj = this.visitMsgList[1];
        type2Obj.brower = this.util.nullToString(response.data.from_url);
        type2Obj.site = response.data.site_name;

        var type3Obj = this.visitMsgList[2];
        type3Obj.px = this.util.nullToString(response.data.dpi);
        type3Obj.osystem = this.util.nullToString(response.data.os);
      }

      this.trailRequest();
    },

    async trailRequest() {
      this.trailList = [];
      const selectClient = this.visitor;
      // const account = this.util.getLocalAccount()
      console.log("quickTalk trailRequest selected = ", selectClient);

      // var csid = account.id
      // if (this.$store.state.keyName === '我的同事') {
      // 	csid = this.$store.state.parentNode.data.data.csid
      // }

      var api = "/manager/chat/customer/traces";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          cid: selectClient.cid,
          csid: selectClient.csid,
          sid: selectClient.sid,
          page: 1,
          size: 99,
        },
      });
      console.log("index trailRequest response = ", response);
      const list = response.data.list;
      if (list !== null) {
        for (var i = 0; i < list.length; i++) {
          const data = list[i];
          var action = "";
          if (data.action === 1) {
            action = "进站";
          } else if (data.action === 2) {
            action = "开始会话";
          } else if (data.action === 3) {
            action = "离站";
          }

          var source = "";
          if (data.source === 1) {
            source = "百度";
          } else if (data.source === 2) {
            source = "360";
          } else if (data.source === 3) {
            source = "谷歌";
          }

          const obj = {
            time: this.util.timeStampToDate(data.occurTime * 1000, 1),
            source: source,
            action: action,
            desc: data.remarks,
            account: this.util.nullToString(data.fromAccout),
          };

          this.trailList.push(obj);
        }

        console.log("***index trailList = ", this.trailList);
      }
    },

    clickQuick() {
      if (this.selectQuick === false) {
        // 重新计算快捷回复列表maxHeight
        setTimeout(() => {
          this.getQuickReplyMaxHeight();
        });
        this.selectQuick = true;
        this.selectVisit = false;
        // this.quickRequest();
        if (this.chart == "") {
          return;
        }
        this.chart.clear(); // 清除画布
        var ecdiv = document.getElementById("echartsDiv");
        var sondiv = ecdiv.firstChild;
        sondiv.style.height = "0px";
        sondiv.style.width = "0px";
        console.log(
          "echartsDiv height width===>",
          sondiv.style.height,
          sondiv.style.width
        );
      }
    },

    clickVisit() {
      if (this.selectVisit === false) {
        this.selectQuick = false;
        this.selectVisit = true;
        if (this.visitor === null) {
          this.showVisitInfo = false;
        } else {
          this.showVisitInfo = true;
          this.visitRequest();
        }
      }
    },

    handleNodeClick(data) {
      this.currentPersonData = data;
      this.currentPersonData.useFlag = false;
      console.log(
        "quickTalk handleNodeClick currentPersonData = ",
        this.currentPersonData
      );
      console.log("currentIndex", this.currentIndex);
      this.$emit("sendQuick", data.content);
    },
    handleSend(data) {
      console.log("===", data);
      // this.$emit("sendQuick", data.content);
    },
    // 树节点展开
    handleNodeExpand(data) {
      console.log("树节点展开：", data);
      // 保存当前展开的节点
      let flag = false;
      this.defaultExpandKeys.some((item) => {
        if (item === data.id) {
          // 判断当前节点是否存在， 存在不做处理
          flag = true;
          return true;
        }
      });
      if (!flag) {
        // 不存在则存到数组里
        this.defaultExpandKeys.push(data.id);
      }
    },

    // 树节点关闭
    handleNodeCollapse(data) {
      console.log("删除字节点", data);
      // 删除当前关闭的节点
      this.defaultExpandKeys.some((item, i) => {
        if (item === data.id) {
          this.defaultExpandKeys.splice(i, 1);
        }
      });
      this.removeChildrenIds(data); // 这里主要针对多级树状结构，当关闭父节点时，递归删除父节点下的所有子节点
    },
    // 删除树子节点
    removeChildrenIds(data) {
      console.log(data);
      const ts = this;
      if (data.children) {
        data.children.forEach(function (item) {
          const index = ts.defaultExpandKeys.indexOf(item.id);
          if (index > 0) {
            ts.defaultExpandKeys.splice(index, 1);
          }
          ts.removeChildrenIds(item);
        });
      }
    },

    renderContent(createElement, { node }) {
      //data, store
      return createElement("span", [
        createElement("span", {
          attrs: {
            class: "tree-img",
          },
        }),
        createElement(
          "span",
          {
            attrs: {
              class: "tree-spt",
            },
          },
          node.label
        ),
      ]);
    },
    highLightText(val) {
      console.log("this.filterText:", this.filterText);
      console.log("this.isExpandAll:", this.isExpandAll, val);
      // if (val === "") {
      //   console.log("搜索词为空val：", val);
      //   return;
      // } else {
      //   this.searchedData.splice(0, this.searchedData.length, "");
      //   // 排除没有目录的
      //   var newTreeData = this.treeData.filter((item) => {
      //     if (item.quickReplyVoList) {
      //       return item;
      //     }
      //   });
      //   var tempSearchedData = [];
      //   // 双重遍历后，判断内容中是否含有搜索词
      //   newTreeData.forEach((item) => {
      //     this.getSearchDate(item, val, tempSearchedData);
      //   });
      //   this.searchedData = tempSearchedData;
      //   console.log("搜索词不为空：", val, tempSearchedData);
      // }
    },
    // 递归  取值
    getSearchDate(obj, val, tempSearchedData) {
      if (obj.quickReplyVoList) {
        obj.quickReplyVoList.forEach((item) => {
          this.getSearchDate(item, val, tempSearchedData);
          // if (
          //   (item.content.indexOf(val) !== -1 ||
          //     item.title.indexOf(val) !== -1) &&
          //   item.content !== ""
          // ) {
          //   tempSearchedData.push({
          //     id: item.id,
          //     title: item.title,
          //     content: item.content,
          //   });
          // }
        });
      } else {
        if (
          (obj.content.indexOf(val) !== -1 || obj.title.indexOf(val) !== -1) &&
          obj.content !== ""
        ) {
          tempSearchedData.push({
            id: obj.id,
            title: obj.title,
            content: obj.content,
          });
        }
      }
    },
    renderHtml2(data) {
      // console.log("QuickTalk.vue renderHtml2 data:", data);
      const title = data.title;
      const content = data.content;
      let str = `<span>${title}</span> &nbsp;&nbsp;<span style='color:#737375; overflow: hidden;
    text-overflow: ellipsis;flex:1;width:0'>${content}</span>`;
      // console.log("QuickTalk.vue renderHtml2 str:", str);

      return str;
    },
    renderHtml1(content) {
      return `<span style='color:#737375'>${content}</span>`;
    },
    changeKeywords(val, keyword) {
      const Reg = new RegExp(keyword, "i");
      let res = "";
      if (val) {
        res = val.replace(
          Reg,
          `<span style="color: #1577d2;">${keyword}</span>`
        );
        return res;
      }
    },
    async getCustBasicInfoAndDisease() {
      console.log(
        "111111111111111111enter getCustBasicInfoAndDisease=====>",
        this.visitor.cid,
        this.visitor.sid
      );
      var cid = this.visitor.cid;
      var sid = this.visitor.sid;
      // var cid = "1626079750895_23290"
      // var sid = "6c085454c05a4503b82f1797f14b706c"
      var api =
        "/manager/custDisease/getCustBasicInfoAndDisease?cid=" +
        cid +
        "&sid=" +
        sid;
      // const account = this.util.getLocalAccount()
      // var data= {
      // 	cid:"1626079750895_23290",
      // 	sid:"6c085454c05a4503b82f1797f14b706c"
      // }
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      console.log("quickTalk tCustBasicInfoAndDisease response = ", response);
      if (response.resultCode === "10000") {
        this.worddata = response.data.custPortraitList;
        this.$nextTick(() => {
          this.initChart();
          var ecdiv = document.getElementById("echartsDiv");
          var sondiv = ecdiv.firstChild;
          sondiv.style.height = "300px";
          sondiv.style.width = "300px";
          sondiv.style.marginTop = "5px";
          sondiv.style.marginLeft = "10px";
          console.log(
            "echartsDiv height width===>",
            sondiv.style.height,
            sondiv.style.width
          );
        });
      } else {
        this.$message.error(response.desc);
      }
    },
    initChart() {
      console.log("initChart", document.getElementById("echartsDiv"));
      this.chart = echarts.init(document.getElementById("echartsDiv"));
      const option = {
        title: {
          title: "用户画像",
          x: "center",
        },
        backgroundColor: "#fff",
        series: [
          {
            type: "wordCloud",
            gridSize: 8,
            sizeRange: [12, 30],
            rotationRange: [-25, 90],
            textStyle: {
              normal: {
                color: function () {
                  return (
                    "rgb(" +
                    Math.round(Math.random() * 255) +
                    "," +
                    Math.round(Math.random() * 255) +
                    "," +
                    Math.round(Math.random() * 255) +
                    ")"
                  );
                },
              },
            },
            shape: "circle",
            left: "center",
            top: "center",
            right: null,
            botoom: null,
            width: "150%",
            height: "150%",
            data: this.worddata,
          },
        ],
      };
      this.chart.setOption(option);
    },
    // 处理智能助手话术数据更新
    handleAIDataUpdate(data) {
      console.log("handleAIDataUpdate data:", data);
      
      // 检查是否有 message 字段
      if (!data || !data.message) {
        console.warn("智能助手话术数据格式不正确，缺少 message 字段");
        this.treeAIData = [];
        return;
      }

      try {
        // 解析 message 字符串为 JSON 数组
        let messageArray = [];
        if (typeof data.message === 'string') {
          messageArray = JSON.parse(data.message);
        } else if (Array.isArray(data.message)) {
          messageArray = data.message;
        } else {
          console.warn("智能助手话术 message 格式不正确");
          this.treeAIData = [];
          return;
        }

        // 转换为树形结构
        const treeData = messageArray.map((model, index) => {
          // 第一层：模型名称（目录）
          const modelNode = {
            id: `ai_model_${index}_${Date.now()}`,
            pId: "0",
            title: model.name || `模型${index + 1}`,
            content: "",
            attributionType: 1,
            dataType: 0, // 目录类型
            quickReplyVoList: []
          };

          // 第二层：处理 response 中的各个回复
          if (model.response && Array.isArray(model.response)) {
            modelNode.quickReplyVoList = model.response.map((responseItem, respIndex) => {
              // responseItem 格式为 {"utter1": "内容"} 或 {"utter2": "内容"} 等
              // 提取第一个键值对作为内容
              const keys = Object.keys(responseItem);
              const content = keys.length > 0 ? responseItem[keys[0]] : "";
              
              return {
                id: `ai_response_${index}_${respIndex}_${Date.now()}`,
                pId: modelNode.id,
                title: content || `回复${respIndex + 1}`, // 使用内容作为标题
                content: content, // 内容
                attributionType: 1,
                dataType: 1, // 内容类型
                useFlag: false
              };
            });
          }

          return modelNode;
        });

        // 处理树形数据，确保格式正确
        this.treeAIData = treeData;
        if (this.treeAIData && this.treeAIData.length > 0) {
          this.treeAIData.forEach((item, index) => {
            this.getTree(index, item);
          });
        }

        console.log("智能助手话术数据已更新:", this.treeAIData);
      } catch (error) {
        console.error("解析智能助手话术数据失败:", error);
        this.treeAIData = [];
        this.$message.error("智能助手话术数据解析失败");
      }
    },
  },
};
</script>

<style scoped lang="scss">
// element-ui 折叠面板公共样式

::v-deep  .el-collapse {
  width: 100%;
  .el-collapse-item__header {
    @include change_size($font_size_normal);
    height: 36px;
    color: #333333;
    background-color: #f1f1f1;
  }
  .el-collapse-item__arrow.is-active {
    transform: none;
  }
  .el-collapse-item__header.is-active {
    background-color: #f1f1f1;
  }
  .el-collapse-item__content {
    padding-bottom: 0;
    overflow: hidden auto;
    // height: 60vh;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .el-icon-arrow-right:before {
    content: "" !important;
  }
}
.aside_div :deep() .el-collapse-item__header {
  @include change_size($font_size_normal);
}

.common-ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.buttons {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.aside_div_edit {
  // position: absolute;
  // right: 5px;
  // top: 0;
  margin-right: 10px;
  color: #03a04e;
  line-height: 37px;
  @include change_size($font_size_normal);
  cursor: pointer;
}
.aside_div_add {
  // position: absolute;
  // right: 5px;
  // top: 0;
  color: #03a04e;
  line-height: 37px;
  @include change_size($font_size_normal);
  cursor: pointer;
}
.title_left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  @include change_size($font_size_normal);
  font-weight: normal;
}
.aside_div_icon {
  width: 20px;
  height: 20px;
  margin-right: 4px;
}

// // 快捷回复弹出框样式---start
::v-deep .el-dialog__wrapper {
  // 对话框居中样式
  // text-align: center;
  // white-space: nowrap;
  // overflow: auto;
  // &:after {
  //   content: "";
  //   display: inline-block;
  //   vertical-align: middle;
  //   height: 100%;
  // }
  .el-dialog {
    // margin: 30px auto !important;
    // display: inline-block;
    // vertical-align: middle;
    // text-align: center;
    // white-space: normal;
    @include change_size($font_size_normal);
    .el-dialog__title {
      display: flex;
      line-height: 1;
      font-weight: 600;
      &::before {
        display: block;
        content: "";
        width: 3px;
        height: auto;
        color: #333333;
        background-color: #1577d2;
        margin-right: 6px;
        // font-family: "MicrosoftYaHei";
      }
    }
    .dialog-footer {
      display: flex;
      justify-content: right;
      justify-items: start;
      // margin-bottom: 0;
    }
    .el-dialog__body {
      padding: 0 20px;
    }
  }
}

// 快捷回复弹出框样---end
.quick_container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  background-color: #ffffff;
}
.quick_btn {
  width: 100%;
  height: 40px;
  padding-top: 0.9375rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  // background-color: yellow;
}

.quick_title {
  @include change_size($title_size_normal);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(68, 68, 68, 0.8);
  margin-left: 0.1875rem;
}

.quick_title_selected {
  @include change_size($title_size_normal);
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #5a9cf8;
  margin-left: 0.1875rem;
}

.blue_line {
  width: 100%;
  height: 4px;
  background: #5a9cf8;
}

.quick_header {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  width: 100%;
}

.gray_line {
  width: 100%;
  height: 1px;
  background: rgba(0, 0, 0, 0.05);
  margin-top: 2px;
}

.nav_div {
  display: flex;
  flex-direction: column;
}

.aside_div {
  width: 100%;
  // height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  // overflow-x: auto;
  .nav_title {
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: rgba(68, 68, 68, 1);
  }

  //  有搜索词时的样式
  .aside_content {
    width: 92%;
    padding: 10px 0 8px;
    margin: 0 auto;
    box-sizing: border-box;
    border-bottom: 2px dashed #ddd;
    .aside_div_lists {
      width: 100%;
      // 多行文本超出隐藏
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      text-overflow: ellipsis;
      word-break: break-all;
      overflow: hidden;
      & > span:nth-of-type(1) {
        @include change_title_size($title_size_normal);
        color: #1577d2;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-break: break-all;
        display: inline-block;
        max-width: 6em;
        overflow: hidden;
        vertical-align: bottom;
      }
      .aside_div_lists-content {
        @include change_size($title_size_normal);
        margin-left: 8px;
      }
    }
  }
}
.aside_div_lists-popover {
  @include change_size($font_size_normal);
}

.search_div {
  width: 100%;
  // height: 5rem;
  // background-color: #4169E1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-items: center;
  margin: 8px 0;
  // flex-grow: 2;
}

.search_inputxx :deep() {
  .el-input__inner {
    @include change_size($font_size_normal);
  }
}
.search_input {
  width: 95%;
  @include change_size($font_size_normal);
  margin-right: 0.1875rem;
  margin-left: 0.1875rem;
}

.visite_outdiv {
  width: 95%;
  height: 92%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: scroll;
  overflow-x: hidden;
  // background-color: cyan;
}

.visite_outdiv::-webkit-scrollbar {
  display: none;
}
.noData_img {
  width: 28px;
  height: 28px;
  margin-top: 300px;
}

.visite_box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 98%;
  margin-top: 10px;
}

.title_lb {
  @include change_size($font_size_normal);
  font-family: PingFang-SC-Bold, PingFang-SC;
  font-weight: bold;
  color: #444444;
  margin-left: 0.9375rem;
}

.content_div {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 90%;
  @include change_size($font_size_normal);
  font-family: PingFang-SC-Bold, PingFang-SC;
  color: #444444;
  margin-top: 3px;
  text-align: left;
  margin-left: 0.9375rem;
  overflow: hidden;
  word-break: break-all;
}

.content_div1 {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 90%;
  @include change_size($font_size_normal);
  font-family: PingFang-SC-Bold, PingFang-SC;
  color: #444444;
  margin-top: 3px;
  text-align: left;
  margin-left: 0.9375rem;
  overflow: hidden;
  word-break: break-all;
  // white-space: nowrap;
}

.tree-divider {
  border-bottom: 1px solid #DCDFE6;
  margin-top: 0px; 
  width: 100%;
  position: relative;
  left: 0px;
  margin-right: 0px;
  transform: scaleY(0.5);
  transform-origin: 0 0;
}

.content_div::-webkit-scrollbar {
  display: none;
}
.tree_box {
  background-color: rgba(37, 204, 247, 0);
  width: 98%;
  overflow: scroll;
  overflow-x: hidden;
}
.tree_box::-webkit-scrollbar {
  display: none;
}
.custom-tree-node {
  flex: 1;
  // display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  @include change_size($font_size_normal);
  padding-right: 0;
}
.tree-node2 {
  border-bottom: 1px dashed #ddd;
  padding: 2px 0;
}
.el-tree-node__children .el-tree-node:last-child .tree-node2 {
  border-bottom: none;
}
.custom-tree-iconBox {
  width: 100%;
}
.tree-node2 {
  width: 100%;
}
.custom-tree-icon {
  min-width: 120px;
  text-align: right;
  img {
    width: 13px;
    height: 13px;
    margin-left: 8px;
    vertical-align: middle;
  }
}
.custom-tree-node-content {
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-tree-node__label {
  width: auto;
  margin-top: 12px;
  float: right;
  font-family: “Trebuchet MS”, Arial, Helvetica, sans-serif;
  font-size: 14px;
  color: red;
  line-height: 25px;
  letter-spacing: 1px;
}
::v-deep  .el-tree-node__content {
  padding-left: 0 !important;
  height: auto;
  & > .el-tree-node__expand-icon {
    padding: 0;
    padding-right: 6px !important;
  }
}

.pop_span,
.pop_span1 {
  display: flex;
  align-items: center;
 // color: #1577d2;
  color: #2440b3;
    font-weight: bold;
}

// .pop_span1 {
//   overflow: hidden;
//   text-overflow: ellipsis;
//   text-align: left;
//   color: rgba(90, 156, 248, 0.8);
// }
.searchAside_div {
  &::-webkit-scrollbar {
    display: none;
  }
  overflow-y: auto;
}

/* .el-tree-node__content {
		&:hover {
			background: #89c2f7;
		}
	}

	.el-tree-node:focus>.el-tree-node__content {
		background-color: #5daaf0 !important;
	}

	.el-menu-item.is-active {
		background-color: rgb(201, 188, 80) !important;
	}
	.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
		background-color:  #F56C6C;
	}

	.el-tree-node.is-current > .el-tree-node__content {
		background-color: red !important;
	} */
</style>
